/**
 * Date constants for the Schedule and Trip functionality
 */

// Minimum date for all schedule-related date pickers
// Prevents new customers from seeing/selecting dates before 2025
export const SCHEDULE_MIN_DATE = new Date("2025-01-02");

// Maximum date for all schedule-related date pickers
// Provides a reasonable upper bound for trip scheduling
export const SCHEDULE_MAX_DATE = new Date("2030-12-31");
